import { useContext, useMemo } from 'react';

import MutationDataProviderContext from './MutationDataProviderContext';

const useMutationDataProvider = () => {
    const mutationDataProvider = useContext(MutationDataProviderContext);

    // const logoutIfAccessDenied = useLogoutIfAccessDenied();

    const mutationDataProviderProxy = useMemo(() => {
        return new Proxy(mutationDataProvider, {
            get: (target, name) => {
                if (typeof name === 'symbol' || name === 'then') {
                    return;
                }
                return (...args) => {
                    const type = name.toString();

                    if (typeof mutationDataProvider[type] !== 'function') {
                        throw new Error(
                            `Unknown mutationDataProvider function: ${type}`
                        );
                    }

                    try {
                        return mutationDataProvider[type]
                            .apply(mutationDataProvider, args)
                            .then(response => {
                                if (process.env.NODE_ENV !== 'production') {
                                    console.log(response);
                                    console.log(type);
                                    // validateResponseFormat(response, type);
                                }
                                return response;
                            })
                            .catch(error => {
                                if (process.env.NODE_ENV !== 'production') {
                                    console.error(error);
                                }
                                return Promise.resolve(false);
                            });
                    } catch (e) {
                        if (process.env.NODE_ENV !== 'production') {
                            console.error(e);
                        }
                        throw new Error(
                            'The mutationDataProvider threw an error. It should return a rejected Promise instead.'
                        );
                    }
                };
            },
        });
        // }, [mutationDataProvider, logoutIfAccessDenied]);
    }, [mutationDataProvider]);

    return mutationDataProviderProxy;
};

export default useMutationDataProvider;